// extracted by mini-css-extract-plugin
export default {"phone":"phone_phone__FFvgR"};